import axios from 'axios';

export default axios.create({
  baseURL: 'https://gentle-atoll-23665.herokuapp.com/',
});
